import { View } from 'react-native';
import * as Linking from 'expo-linking';
import { Button } from '@/components/ui/Button';
import { Caption } from '@/components/ui/Text';
import { useTheme } from '@/theme';

type CheckInButtonProps = {
  available: boolean;
  onPress?: () => void;
  isLoading?: boolean;
  checkInLink?: string | null;
};

export function CheckInButton({
  available,
  onPress,
  isLoading,
  checkInLink,
}: CheckInButtonProps) {
  const theme = useTheme();

  const handlePress = () => {
    if (onPress) {
      onPress();
      return;
    }

    if (checkInLink) {
      Linking.openURL(checkInLink).catch((error) => {
        console.error('Failed to open check-in link', error);
      });
    }
  };

  if (!available) {
    return (
      <View
        style={{
          padding: theme.spacing(1.5),
          borderRadius: theme.radii.lg,
          backgroundColor: theme.colors.overlay,
        }}
      >
        <Caption color={theme.colors.textSecondary}>
          Online check-in will be available 24 hours before departure.
        </Caption>
      </View>
    );
  }

  return (
    <View style={{ gap: theme.spacing(0.5) }}>
      <Button
        label={isLoading ? 'Opening...' : 'Open Airline Check-In'}
        onPress={handlePress}
        disabled={isLoading || (!onPress && !checkInLink)}
      />
      {checkInLink && (
        <Caption color={theme.colors.textSecondary} numberOfLines={2}>
          {checkInLink}
        </Caption>
      )}
    </View>
  );
}

